'use client'

import { useState } from 'react'
import { Dialog, DialogPanel, Disclosure, DisclosureButton, DisclosurePanel, Popover, PopoverButton, PopoverPanel } from '@headlessui/react'
import { Bars3Icon, BuildingStorefrontIcon, ChevronDownIcon, ChevronUpIcon, EnvelopeIcon, MapPinIcon, PhoneIcon, XMarkIcon } from '@heroicons/react/24/outline'
import ats from './data'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next';


const navigation = ats.nav.links;
const morenav = ats.nav.sublinks;
const info = ats.info;

function HeaderATS() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { t } = useTranslation();

  /*const handleChangeLanguage = () => {
    if (i18n.language === 'en') {
      i18n.changeLanguage('es');
    } else {
      i18n.changeLanguage('en');
    }
  }*/

  return (
    <header className="bg-white">
      <nav aria-label="Global" className="mx-auto flex max-w-7xl items-center justify-between gap-x-6 p-6 lg:px-8">
        <div className="flex lg:flex-1">
          <a href="/" className="-m-1.5 p-1.5">
            <span className="sr-only">{info.name}</span>
            <img
              alt={info.name}
              title={info.name}
              src={process.env.PUBLIC_URL + "/static/atsauto_logo_sm.png"}
              className="w-28 h-auto"
            />
          </a>
        </div>
        <div className="hidden lg:flex lg:gap-x-12">
          {navigation.map((item) => (
            <Link key={item.name} to={item.href} className="text-sm font-semibold leading-6 text-gray-900">
              {t(item.name)}
            </Link>
          ))}
          <Popover className="relative">
            <PopoverButton className="flex items-center gap-x-1 text-sm font-semibold leading-6 text-gray-900">
              {t('more')}
              <ChevronDownIcon aria-hidden="true" className="h-5 w-5 flex-none text-gray-400" />
            </PopoverButton>

            <PopoverPanel
              transition
              className="absolute -left-8 top-full z-10 mt-3 w-56 rounded-xl bg-white p-2 shadow-lg ring-1 ring-gray-900/5 transition data-[closed]:translate-y-1 data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in"
            >
              {morenav.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className="block rounded-lg px-3 py-2 text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-50"
                >
                  {t(`${item.name}`)}
                </Link>
              ))}
            </PopoverPanel>
          </Popover>
        {/*<button
          type="button"
          className="rounded bg-white px-2 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
        >
          {t('opposite_language')}
        </button>*/}
        </div>
        <div className="flex flex-1 items-center justify-end gap-x-6">
          <a href={`tel:${info.tel}`} className='font-bold'><PhoneIcon className='w-5 inline-block' /> {info.tel}</a>
        </div>
        <div className="flex lg:hidden">
          <button
            type="button"
            onClick={() => setMobileMenuOpen(true)}
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
          >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon aria-hidden="true" className="h-6 w-6" />
          </button>
        </div>
      </nav>
      <Dialog open={mobileMenuOpen} onClose={setMobileMenuOpen} className="lg:hidden">
        <div className="fixed inset-0 z-10" />
        <DialogPanel className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
          <div className="flex items-center gap-x-6">
            <a href="/" className="-m-1.5 p-1.5">
            <span className="sr-only">{info.name}</span>
            <img
              alt={info.name}
              title={info.name}
              src={process.env.PUBLIC_URL + "/static/atsauto_logo_sm.png"}
              className="w-28 h-auto"
            />
            </a>
            <a
              href={`tel:${info.tel}`}
              className="ml-auto font-bold text-gray-900"
            ><PhoneIcon className='w-5 inline-block' /> {info.tel}
            </a>
            <button
              type="button"
              onClick={() => setMobileMenuOpen(false)}
              className="-m-2.5 rounded-md p-2.5 text-gray-700"
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon aria-hidden="true" className="h-6 w-6" />
            </button>
          </div>
          <div className="mt-4 flow-root">
            <div className="-my-6 divide-y divide-gray-500/10">
              
              <div className="space-y-2 py-6">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                  >
                    {t(`${item.name}`)}
                  </Link>
                ))}
                <hr className="my-6 border-gray-500/10" />
                <div className='relative'>
                  <Disclosure as="div" className="pt-6">
                    <DisclosureButton className="group flex w-full items-start justify-between text-left text-gray-900">
                        <span className="text-base font-semibold leading-7">More</span>
                        <span className="ml-6 flex h-7 items-center">
                          <ChevronDownIcon aria-hidden="true" className="h-6 w-6 group-data-[open]:hidden" />
                          <ChevronUpIcon aria-hidden="true" className="h-6 w-6 [.group:not([data-open])_&]:hidden" />
                        </span>
                      </DisclosureButton>
                    {morenav.map((moblink) => (
                    <DisclosurePanel key={moblink.name} as="dd" className="mt-2 py-2 pr-12 ml-4">
                      <a href={moblink.href} className="text-base leading-7 text-gray-600">{moblink.name}</a>
                    </DisclosurePanel>
                    ))}
                </Disclosure>
                </div>
              </div>
              <div className="py-6">
                <p className="text-lg leading-6 text-gray-900 font-bold">
                  {info.name}
                </p>
                <p className="mt-6 flex items-center gap-x-6">
                  <MapPinIcon className='w-5 h-5 inline' /> {info.address1} <br />{info.address2}</p>
                <p className="mt-6 flex items-center gap-x-6">
                  <PhoneIcon className='w-5 h-5 inline' /><a href={`tel:${info.tel}`}>{info.tel}</a>
                </p>
                <p className="mt-6 flex items-center gap-x-6">
                  <EnvelopeIcon className='w-5 h-5 inline' /><a href={`mailto:${info.email}`}>{info.email}</a>
                </p>
                <p className="mt-6 flex items-center gap-x-6">
                  <BuildingStorefrontIcon className='w-5 h-5 inline' />{t('mon_fri')}: 9am-7pm <br /> {t('sat_sun')}: {t('closed')}
                </p>
              </div>
              <div className='py-6'>
              <div className='flex justify-center'>
                {/*<button
                  type="button"
                  className="rounded bg-white px-2 py-1 text-base font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                >
                  {t('opposite_language')}
                </button>*/}
                </div>
              </div>
            </div>
          </div>
        </DialogPanel>
      </Dialog>
    </header>
  )
}

export default HeaderATS;